import { useEffect } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/layout/PageHeader";
import FAQAccordion from "../components/features/FAQAccordion";
import { FAQS } from "../lib/faqs";
import { setPageMeta, JsonLd, faqSchema, breadcrumbSchema, speakableSchema } from "../lib/schema";

export default function FAQPage() {
  useEffect(() => {
    setPageMeta({
      title: "FAQ — UK to Nigeria Personal Shopping | MPS",
      description:
        "Frequently asked questions about My Private Shopper — service tiers, pricing, delivery times to Nigeria, payment, customs, gifts, B2B, and luxury sourcing.",
      canonical: "https://privateshopper.co.uk/faq",
    });
  }, []);

  return (
    <>
      <JsonLd data={faqSchema(FAQS)} />
      <JsonLd data={breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "FAQ" },
      ])} />
      <JsonLd data={speakableSchema(["[data-testid='page-header'] h1", "[data-testid='page-header'] p", ".max-w-3xl"])} />
      <PageHeader
        overline="FAQ"
        title={<>Straight answers to <span className="italic text-[#C9A96E]">22 common questions</span>.</>}
        body="If we have not answered yours, tap the WhatsApp button — a concierge will reply within hours."
      />

      <section className="container-mps py-20 md:py-28">
        <div className="max-w-3xl mx-auto">
          <FAQAccordion items={FAQS} testIdPrefix="faqpage" />
          <div className="mt-16 p-10 bg-[#0A0A0A] text-[#F8F5F0] text-center">
            <h2 className="font-serif text-3xl md:text-4xl">Still have a question?</h2>
            <p className="mt-4 text-[#F8F5F0]/70 max-w-lg mx-auto">
              We answer within a few hours, every working day.
            </p>
            <Link
              to="/contact"
              data-testid="faq-contact-cta"
              className="mt-8 inline-flex items-center justify-center px-8 py-4 bg-[#C9A96E] text-[#0A0A0A] text-sm uppercase tracking-[0.2em] hover:bg-[#A68A52]"
            >
              Contact a Concierge
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
